/**
 * Quiz Player — shell for rendering quizzes in #student-container.
 * Full quiz implementation deferred to a later session.
 * Supports matching, multiple choice, and fill-in-the-blank question types.
 */

import { navigate } from '../../router';

export function renderQuizPlayer(container: HTMLElement, quizId: string): void {
  container.innerHTML = `<div id="quiz-player">
    <div class="quiz-header">
      <button class="quiz-back-btn" id="quiz-back">&#x2190; Back to Dashboard</button>
      <span class="quiz-title">Quiz: ${quizId}</span>
    </div>
    <div class="quiz-body">
      <div class="quiz-placeholder">
        Quiz content for <strong>${quizId}</strong> will be loaded here.
        <br><br>
        <span style="color:#666">Quiz implementation coming soon.</span>
      </div>
    </div>
  </div>`;

  container.querySelector('#quiz-back')?.addEventListener('click', () => {
    navigate('/');
  });
}
